import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IconComponent } from '../icon/icon';
import type { IconName } from '../icon/icon';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ui-empty-state',
  imports: [IconComponent],
  styleUrl: './empty-state.scss',
  templateUrl: './empty-state.html',
})
export class EmptyStateComponent {
  /** Icône illustrative. */
  readonly icon = input<IconName>('inbox');

  /** Titre de l'état vide. */
  readonly title = input('Aucune donnée');

  /** Message explicatif. */
  readonly description = input('');

  /** Contenu d'action projeté (bouton, lien...). */
  readonly compact = input(false);
}
